import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 0c2 3 5 6 8 8-3 2-6 5-8 8-2-3-5-6-8-8 3-2 6-5 8-8"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarFilledSize16Glyph.displayName = 'HyperstarFilledSize16Glyph';
